module.exports = __webpack_public_path__ + "img/itdd_2.f2853aec.jpg";